import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import AuthCallback from "@/components/AuthCallback";
import Admin from "@/pages/Admin";
import RadioPage from "@/pages/Radio";
import Overview from "@/pages/Overview";
import { LanguageProvider } from "@/context/LanguageContext";
import Header from "@/components/Header";
import Home from "@/pages/Home";
import Quiz from "@/pages/Quiz";
import Passport from "@/pages/Passport";
import { Toaster } from "@/components/ui/sonner";
import Compare from "@/pages/Compare";
import Privacy from "@/pages/Privacy";
import PrintGuide from "@/pages/PrintGuide";
import PrintRecipe from "@/pages/PrintRecipe";
import Cookbook from "@/pages/Cookbook";
import Ebook from "@/pages/Ebook";
import Story from "@/pages/Story";
import Itineraries from "@/pages/Itineraries";
import Kit from "@/pages/Kit";
import Guess from "@/pages/Guess";
import DeleteData from "@/pages/DeleteData";
import Rules from "@/pages/Rules";
import ReportFeedback from "@/components/ReportFeedback";
import Introduction from "@/pages/Introduction";
import PaymentSuccess, { PaymentCancel } from "@/pages/PaymentSuccess";
import AnalyticsTracker from "@/components/AnalyticsTracker";
import InstallBanner from "@/components/InstallBanner";
import MiniPlayer from "@/components/MiniPlayer";
import BottomNav from "@/components/BottomNav";
import { RadioProvider } from "@/context/RadioContext";

function AppRoutes() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/quiz" element={<Quiz />} />
      <Route path="/passport" element={<Passport />} />
      <Route path="/compare" element={<Compare />} />
      <Route path="/privacy" element={<Privacy />} />
      <Route path="/elimina-dati" element={<DeleteData />} />
      <Route path="/delete-data" element={<DeleteData />} />
      <Route path="/regole" element={<Rules />} />
      <Route path="/rules" element={<Rules />} />
      <Route path="/guide/:code" element={<PrintGuide />} />
      <Route path="/recipe/:code/:kind" element={<PrintRecipe />} />
      <Route path="/ricettario" element={<Cookbook />} />
      <Route path="/cookbook" element={<Cookbook />} />
      <Route path="/ebook" element={<Ebook />} />
      <Route path="/story/:code" element={<Story />} />
      <Route path="/itinerari" element={<Itineraries />} />
      <Route path="/strumenti" element={<Kit />} />
      <Route path="/kit" element={<Kit />} />
      <Route path="/indovina" element={<Guess />} />
      <Route path="/introduzione" element={<Introduction />} />
      <Route path="/payment/success" element={<PaymentSuccess />} />
      <Route path="/payment/cancel" element={<PaymentCancel />} />
      <Route path="/admin" element={<Admin />} />
      <Route path="/radio" element={<RadioPage />} />
      <Route path="/overview" element={<Overview />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App min-h-screen pb-16 md:pb-0 print:pb-0">
      <LanguageProvider>
        <BrowserRouter>
          <AuthProvider>
            <RadioProvider>
              <AnalyticsTracker />
              <ReportFeedback />
              <Header />
              <AppRoutes />
              <MiniPlayer />
              <BottomNav />
              <InstallBanner />
              <Toaster position="bottom-center" richColors closeButton mobileOffset={{ bottom: 84 }} />
            </RadioProvider>
          </AuthProvider>
        </BrowserRouter>
      </LanguageProvider>
    </div>
  );
}

export default App;
